import { $isEmptyObject } from "@/utils/components/helper";
// 组件列表
const EXPORT_COMPONENTS = {};

// 注册组件
const modulesFiles = require.context(`../components/`, true, /index.js$/);

modulesFiles.keys().forEach(key => {
  let modules = modulesFiles(key);
  // 非空对象（兼容common下的index.js）
  if (!$isEmptyObject(modules)) {
    modules = modules.default;
    const { mapping, config, component } = modules;
    if (mapping && config && component) {
      // 提取组件名
      const [, componentName] = key.split("/");
      EXPORT_COMPONENTS[componentName] = { component, mapping, config };
    }
  }
});

// vue use install
const install = {
  install(Vue, opts = {}) {
    if (install.installed) { return; }
    Object.keys(EXPORT_COMPONENTS).forEach(key => {
      const { component } = EXPORT_COMPONENTS[key];
      // 注册组件
      Vue.component(key, component);
      Vue.prototype.$__EXPORTCOMPONENTS__ = EXPORT_COMPONENTS;
    });
  }
};

export default { install, EXPORT_COMPONENTS };
